/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type CharityContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProfileDonateHeartsContainer_user$ref: FragmentReference;
export type ProfileDonateHeartsContainer_user = {|
  +$fragmentRefs: CharityContainer_user$ref,
  +$refType: ProfileDonateHeartsContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "ProfileDonateHeartsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CharityContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'fe70f6383e8f67c21c5d8c52123b6099';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Settings/Profile/__generated__/ProfileDonateHeartsContainer_user.graphql.js